import React from 'react';
import '../Components/favorite.css'
import favorite from '../imgs/favourite.jpg'
import { Slide } from 'react-reveal';

function Favorite() {
  return (
    <div className='favo'>
      <h2 className='favoHead'>Our favorite </h2>
      
      <div className="favoContent">
           
      <Slide left >
					<img src={favorite} className="favImage" alt="cake" />
				</Slide>
				<Slide right>
					<div className="textContent">
						<p>
							Strawberries and cream and spice with a zip of balsamic. This cake
							celebrates all the classic strawberry combinations, a little like a
							greatest hits album, but way more delicious!
						</p>
					</div>
				</Slide>
        
      </div>

         <button className="favoBtn">Order Now</button> 
    </div>
  )
}

export default Favorite;
